<template>
    <div class="auth-statement" :key="$route.fullPath">
        <div class="line">
            <img src="@assets/images/line.jpg" />
        </div>
        <div v-html="content" class="content" ref="contentDiv"></div>
        <div v-if="justPreview == false || contentArray.length > 1">
            <div style='height:1.20rem;'></div>
            <div class='footer acea-row row-middle'>
                <button class='btn-submit' @click="onClickBtn" :disabled="isDisabled">{{ btnText }}</button>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { realNameAuth, getAuthStatement, getMyAuthStatement, autoCheckAuth } from "@api/user";
import { VUE_APP_API_URL } from "@utils";

const READ_SECONDS = 5;

export default {
    name: "AuthStatement",
    components: {
    },
    props: {},
    data: function () {
        return {
            realNameParamData: this.$route.query,
            content: '',
            contentArray: [],
            contentIndex: 0,
            btnText: '数据加载中...',
            isDisabled: false,
            justPreview: true
        };
    },
    computed: mapGetters(["userInfo"]),
    mounted: function () {
        this.justPreview = !this.realNameParamData.name;
        this.getAuthStatement();
    },
    methods: {
        getAuthStatement() {
            this.$dialog.loading.open("正在加载中");
            let that = this;
            if (that.justPreview) {
                getMyAuthStatement().then(res => {
                    that.$dialog.loading.close();
                    that.contentArray = res.data.contentArray,
                    that.content = res.data.contentArray[0];
                    that.contentIndex = 0,
                    that.btnText = '下一条（' + (that.contentIndex + 1) + '/' + res.data.contentArray.length + '）'
                }).catch(err => {
                    that.$dialog.loading.close();
                    that.$dialog.error(err.msg || "数据加载失败");
                    setTimeout(() => {
                        that.$router.go(-1);
                    }, 2000);
                })
            }
            else {
                let userName = this.realNameParamData.name;
                let cardId = this.realNameParamData.cardId;
                let address = this.realNameParamData.address.replace(/\[\#\]/g, '');
                let phone = this.realNameParamData.phone;
                getAuthStatement({
                    userName: userName,
                    cardId: cardId,
                    address: address,
                    phone: phone
                }).then(res => {
                    that.runNum();
                    that.$dialog.loading.close();
                    that.contentArray = res.data.contentArray,
                    that.content = res.data.contentArray[0],
                    that.contentIndex = 0,
                    that.btnText = '至少还需阅读 ' + READ_SECONDS + ' 秒';
                }).catch(err => {
                    that.$dialog.loading.close();
                    that.$dialog.error(err.msg || "数据加载失败");
                    setTimeout(() => {
                        that.$router.go(-1);
                    }, 2000);;
                })
            }
        },
        runNum() {
            let that = this;
            let n = READ_SECONDS;
            const run = setInterval(function () {
                n--;
                if (n == 0) {
                    clearInterval(run);
                    if (that.contentIndex == that.contentArray.length - 1) {  //已经最后一条
                        that.isDisabled = false;
                        that.btnText = '同意授权并提交认证';
                    } else {
                        that.isDisabled = false;
                        that.btnText = '下一条（' + (that.contentIndex + 1) + '/' + that.contentArray.length + '）';
                    }
                } else {
                    that.btnText = "至少还需阅读 " + n + " 秒";
                    that.isDisabled = true;
                }
            }, 1000);
        },
        submitRealName(){
            this.$dialog.loading.open("数据提交中...");
            let that = this;
            const redirect = this.realNameParamData.redirect || "";
            const paramData = { ...this.realNameParamData };
            delete paramData.redirect;
            paramData.isPreCheck = false;
            realNameAuth(paramData).then(res => {
                that.$dialog.loading.close();
                const query = { msg: res.msg };
                if (redirect) {
                    query.redirect = redirect;
                }
                that.$router.push({
                    path: "/user/auth_status",
                    query
                });
                autoCheckAuth(res.data).then(res => { }).catch(err => { });
            }).catch(err => {
                that.$dialog.loading.close();
                that.$dialog.error(err.msg || "数据提交失败");
            })
        },
        onClickBtn() {
            let that = this;
            if(that.justPreview) {
                if(that.contentIndex == that.contentArray.length - 1) {  //已经最后一条
                    that.$router.go(-1);
                } else {
                    let nextContentIndex = that.contentIndex + 1;
                    let nextContent = that.contentArray[nextContentIndex];
                    let btnText = '';
                    if((nextContentIndex + 1) == that.contentArray.length) {
                        btnText = '返回';
                    } else {
                        btnText = '下一条（' + (nextContentIndex + 1) + '/' + that.contentArray.length + '）';
                    }
                    that.btnText = btnText;
                    that.content = nextContent;
                    that.contentIndex = nextContentIndex;
                    that.$nextTick(() => {
                        document.documentElement.scrollTop = 0;
                    });
                }
            } 
            else {
                if(that.contentIndex == that.contentArray.length - 1) {  //已经最后一条
                    that.submitRealName();
                } else {
                    let nextContentIndex = that.contentIndex + 1;
                    let nextContent = that.contentArray[nextContentIndex];
                    that.btnText = "至少还需阅读 " + READ_SECONDS + " 秒";
                    that.isDisabled = true;
                    that.content = nextContent,
                    that.contentIndex = nextContentIndex;
                    that.runNum();
                    this.$nextTick(() => {
                        document.documentElement.scrollTop = 0;
                    });
                }
            }
        }
    }
};
</script>

<style>
.auth-statement {
    width: 100%;
    overflow-x: hidden;
}

.auth-statement .content {
    padding: 0.1rem 0.3rem 1rem 0.3rem;
    background-color: #f5f5f5;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
}

.auth-statement .footer {
  position: fixed;
  width: 100%;
  background-color: #fff;
  bottom: 0;
  height: 1.36rem;
  padding-bottom: 0.20rem;
  box-sizing: border-box;
}

.auth-statement .footer .btn-submit {
  width: 3.80rem;
  height: 0.76rem;
  border-radius: 0.50rem;
  text-align: center;
  line-height: 0.76rem;
  font-size: 0.30rem;
  color: #fff;
  margin: auto;
  background-color: #E93323;
}

/* .auth-statement .footer .btn-submit .iconfont {
  font-size: 35r;
  margin-right: 8rpx;
  vertical-align: -1rpx;
} */

</style>
